/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Finals_Min_RoundsInputs */



/**
* | output |
* | --- |
* | "Need at least 2 rounds before finals" |
*
* @param {Err_Tournament_Finals_Min_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_finals_min_rounds = /** @type {((inputs?: Err_Tournament_Finals_Min_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Finals_Min_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Au moins 2 rondes sont nécessaires avant la finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se necesitan al menos 2 rondas antes de las finales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("São necessárias pelo menos 2 rodadas antes das finais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sono necessari almeno 2 round prima delle finali")
	return /** @type {LocalizedString} */ ("Need at least 2 rounds before finals")
});